'use strict';

function reinsurancePanelWidth() {
    var isTablet = window.matchMedia('(max-width: 768px)').matches;
    var windowWidth = $(window).width();
    if (isTablet) {
        $('.reinsurance-panel .panel-wrapper').css({width: windowWidth, right: -windowWidth});
        $('.reinsurance-panel .product-details-wrapper ').css({width: windowWidth});
    } else {
        $('.reinsurance-panel .panel-wrapper').css({width: '', right: ''});
        $('.reinsurance-panel .product-details-wrapper ').css({width: ''});
    }
}

function handleReinsuranceButtons() {
    $(document).on('click', '.panel-content-buttons .panel-bottom-yes, .panel-content-buttons .panel-bottom-no', function () {
        $(this).addClass('activeReinsuranceRatingButton');
        $('.panel-content-buttons .panel-bottom-yes, .panel-content-buttons .panel-bottom-no').css('pointer-events', 'none');
    });
}

function closeReinsurancePanel(){
    $(document).on('click', '.reinsurance-panel .icon-close', function () {
        $(this).closest('.reinsurance-panel').removeClass('opened');
        setTimeout(function() {$('.reinsurance-panel').removeAttr('style')}, 500);
        $('html').removeClass('filter-open');
    });
}

function closeReinsuranceOutsideClick() {
    var selector = '.reinsurance-panel .panel-overlay';
    $(document).off('click', selector);
    $(document).on('click', selector, function(e) {
        e.stopPropagation();
        $(this).closest('.reinsurance-panel').removeClass('opened');
        $('html').removeClass('filter-open');
    });
}

var openReinsurancePanel = function (contentAssetId) {
    var panelBodyElelement = $('.reinsurance-panel .panel-body');
    var isTablet = window.matchMedia('(max-width: 768px)').matches;
    $.ajax({
        url: Urls.displayReinsuranceOverlay+'?cid='+contentAssetId,
        type: 'GET'
    }).done(function (response) {
        $('.reinsurance-panel').removeAttr('style').addClass('opened');
        $('html').addClass('filter-open');
        $('.reinsurance-panel .panel-header h3').html(response.name);
        panelBodyElelement.find('.panel-body-content').html(response.content);
        $('.panel-content-buttons .panel-bottom-yes, .panel-content-buttons .panel-bottom-no')
            .removeClass('activeReinsuranceRatingButton')
            .css('pointer-events', 'auto');
        var panelHeight = $('.reinsurance-panel .panel-wrapper').height();
        if(isTablet) {
            var panelBodyHeight = panelBodyElelement.find('.panel-body-content').height() + 240;
        } else {
            var panelBodyHeight = panelBodyElelement.find('.panel-body-content').height() + 220;
        }

        if(panelBodyHeight > panelHeight) {
            panelBodyElelement.find('.panel-bottom-content').css({
                'position': 'static',
                'margin-bottom': '0'
            });
        } else {
            panelBodyElelement.find('.panel-bottom-content').css({
                'position': 'absolute',
                'margin-bottom': '40px'
            });
        }
    });
}


$(document).ready(function() {
    closeReinsurancePanel();
    closeReinsuranceOutsideClick();
    handleReinsuranceButtons();
    reinsurancePanelWidth();
});

export default{ openReinsurancePanel };
